<template>
  <a :href="href" class="button button-red">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    href: {
      default: ""
    }
  }
};
</script>

<style scoped>
.button:link,
.button:visited {
  text-transform: uppercase;
  text-decoration: none;
  padding: 15px 40px;
  display: inline-block;
  border-radius: 100px;
  transition: all 0.2s;
  position: relative;
}
.button:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.button:active {
  transform: translateY(-1px);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}

.button-red {
  background-color: #e74c3c;
  color: #ffffff;
  border: 2px solid #212f3d;
}

.button::after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 100%;
  border-radius: 100px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  transition: all 0.4s;
}

.button-red::after {
  background-color: #e74c3c;
}

.button:hover::after {
  transform: scaleX(1.4) scaleY(1.6);
  opacity: 0;
}
</style>
